'use client';

import React, { PropsWithChildren } from 'react';
import { NavigationNode, NavigationRestAttributes } from '@/src/lib/navigation/type';
import Link from 'next/link';
import classNames from 'classnames';
import { usePathname } from 'next/navigation';
import { isActiveNavigationNode } from '@/src/lib/navigation/utils';
import { eventBus } from '@/src/lib/core/event/bus';
import { EventBusName } from '@/src/lib/core/event/types';
import { CatalogRequestParams } from '@/src/lib/category/types';

export interface NavigationProps {
  navigation: NavigationRestAttributes;
}

function NavigationClient(props: PropsWithChildren<NavigationProps>) {
  const pathname = usePathname();

  function onClick(event: React.SyntheticEvent, navigationNode: NavigationNode) {
    if (!navigationNode.children?.length) return;

    event.preventDefault();
    eventBus.emit(EventBusName.HEADER_NAVIGATION_CLICK_OPEN_OFFCANVAS, navigationNode);
  }

  return (
    <nav className="h-full space-x-8 ml-6" data-testid="navigation">
      <ul className="flex h-full space-x-4">
        {props.navigation?.nodes
          ? props.navigation?.nodes.map((navigationItem) =>
              navigationItem.nodeType !== 'label' ? (
                <li key={`${navigationItem.title}-${navigationItem.resourceId}`} className="flex items-center">
                  <Link
                    href={navigationItem.url || ''}
                    className={classNames(
                      'relative z-10 uppercase font-bold -mb-px flex items-center py-3 px-4 text-base transition-colors duration-100 ease-out text-gray-900 hover:text-white no-underline!',
                      {
                        'bg-primary-700': isActiveNavigationNode(navigationItem, pathname),
                      },
                    )}
                    target={navigationItem.nodeType === 'external_url' ? '_blank' : '_self'}
                    aria-current={
                      isActiveNavigationNode(navigationItem, pathname) ? CatalogRequestParams.PAGE : undefined
                    }
                    onClick={(e) => onClick(e, navigationItem)}
                  >
                    {navigationItem.title}
                  </Link>
                </li>
              ) : null,
            )
          : null}
      </ul>
    </nav>
  );
}

export default NavigationClient;
